"use client";

import { useState, useEffect } from "react";
import { RecommendedItems, RecommendedItemsSkeleton } from "../RecommendedItems";
import { Item, getItemList } from "@/lib/api/products";

/**
 * 최근 등록된 매물 섹션
 * 최신순으로 정렬된 상품 표시
 */
export function HomeAIRecommendationSection() {
  const [items, setItems] = useState<Item[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadRecentItems();
  }, []);

  const loadRecentItems = async () => {
    try {
      setLoading(true);

      // 최근 등록된 상품 가져오기
      const result = await getItemList({
        limit: 6,
        sortBy: "createdAt",
        sortOrder: "desc",
        filters: {
          status: "active", // 판매중인 상품만
        },
      });

      if (result.success && result.items) {
        // createdAt 기준으로 정렬 (최신순)
        const sortedItems = [...result.items].sort((a, b) => {
          const aTime = a.createdAt?.toDate
            ? a.createdAt.toDate().getTime()
            : new Date(a.createdAt || 0).getTime();
          const bTime = b.createdAt?.toDate
            ? b.createdAt.toDate().getTime()
            : new Date(b.createdAt || 0).getTime();
          return bTime - aTime;
        });
        setItems(sortedItems.slice(0, 6)); // 최대 6개
      }
    } catch (error) {
      console.error("최근 상품 로드 실패:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="bg-white py-12 px-4">
        <div className="max-w-screen-sm mx-auto">
          <RecommendedItemsSkeleton />
        </div>
      </div>
    );
  }

  if (items.length === 0) {
    return null;
  }

  return (
    <div className="bg-white py-12 px-4">
      <div className="max-w-screen-sm mx-auto">
        {/* 섹션 헤더 */}
        <div className="mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight tracking-[-0.02em] mb-4 text-gray-900">
            최근 올라온 매물
          </h2>
          <p className="text-base sm:text-lg text-gray-600">
            지금 올라온 신규 매물을 확인해보세요
          </p>
        </div>

        {/* 최근 아이템 */}
        <RecommendedItems
          items={items}
          title=""
          showMoreLink={true}
        />
      </div>
    </div>
  );
}

